export const getDropdownOptionsForEnum = (enumObj: object) => {
  return Object.values(enumObj).map((val) => ({
    value: val,
    label: val,
  }))
}
